// analytics.js — Émission d'ÉVÉNEMENTS analytiques vers le backend (append-only, cf events.js).
// Batché (envoi toutes les ~4 s + au unload), privacy-light : user_id = id Nakama (ou 'guest'),
// device grossier (mobile/desktop), session éphémère. Sert à accumuler l'historique pour ES/ML plus tard.
import { nakamaAuth } from './nakamaAuth';

const BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
const device = (typeof navigator !== 'undefined' && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) ? 'mobile' : 'desktop';

let session = 's';
try {
  session = sessionStorage.getItem('vg_sess') || (() => {
    const s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    try { sessionStorage.setItem('vg_sess', s); } catch { /* */ } return s;
  })();
} catch { /* */ }

function uid() { try { const s = nakamaAuth.session; return s && !s._localGuest ? s.user_id : 'guest'; } catch { return 'guest'; } }

let queue = [];
let timer = null;

export function track(event, props) {
  props = props || {};
  const e = {
    event, user_id: uid(), device, session,
    game: props.game, channel: props.channel, metric: props.metric, value: props.value,
    props: props.extra,
  };
  Object.keys(e).forEach((k) => e[k] === undefined && delete e[k]);
  queue.push(e);
  if (!timer) timer = setTimeout(flush, 4000);
}

function flush() {
  timer = null;
  if (!queue.length || !BASE) return;
  const batch = queue.splice(0, 50);
  try {
    fetch(`${BASE}/events`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ events: batch }), keepalive: true,
    }).catch(() => {});
  } catch { /* */ }
}

// app_open : une fois par session.
export function trackAppOpen() {
  try { if (sessionStorage.getItem('vg_ev_open')) return; sessionStorage.setItem('vg_ev_open', '1'); } catch { /* */ }
  track('app_open');
}

if (typeof window !== 'undefined') window.addEventListener('beforeunload', flush);
